import classNames from 'classnames';
import { createElement, ReactNode } from 'react';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import styles from './Heading.module.scss';

type Size = '100' | '200' | '300' | '400' | '500' | '600' | '700';

type Color = 'inverse' | 'secondary';

type Props = {
  as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  children: ReactNode;
  className?: string;
  color?: Color;
  id?: string;
  size: Size | { initial: Size; md: Size };
};

function sizeClassNames(size: Props['size']): string {
  if (typeof size === 'object') {
    return classNames(styles[`heading${size.initial}`], styles[`headingMd${size.md}`]);
  }

  return styles[`heading${size}`];
}

// https://www.figma.com/design/9Y1n3VoMJAcTGPe82bvySj/Denali-Components?node-id=18338-83084&m=dev
// Similar components
// https://www.radix-ui.com/themes/docs/components/heading
// https://primer.style/product/components/heading/
export default function Heading({ as, children, className, color, id, size }: Props) {
  return createElement(
    as,
    { ...setDenaliAttribute('Heading'), className: classNames(styles.heading, sizeClassNames(size), color && styles[color], className), id },
    children
  );
}
